import { render, staticRenderFns } from "./game-item.vue?vue&type=template&id=a991c368&scoped=true&"
import script from "./game-item.vue?vue&type=script&lang=js&"
export * from "./game-item.vue?vue&type=script&lang=js&"
import style0 from "./game-item.vue?vue&type=style&index=0&id=a991c368&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a991c368",
  null
  
)

export default component.exports